import React from 'react';
import PropTypes from 'prop-types';

import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';
import Icon from './Icon';

const Avatar = ({ children, iconProp, status, ...rest }) => (
	<Div {...rest}>
		{!rest.bgImg && (children || <Icon name="UserSolid" color="white" {...iconProp} />)}
		{status && (
			<Icon
				name="Status"
				pos="absolute"
				bottom={rest.rounded === 'circle' && '2px'}
				top={rest.rounded === 'circle' ? 'auto' : '-4px'}
				right={rest.rounded === 'circle' ? '1px' : '-4px'}
				size="8px"
				{...status}
			/>
		)}
	</Div>
);

/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

Avatar.propTypes = {
	children: PropTypes.any,
	iconProp: PropTypes.object,
	status: PropTypes.object,
	bg: PropTypesRepo.bg,
	textColor: PropTypesRepo.textColor,
	h: PropTypesRepo.h,
	w: PropTypesRepo.w,
	textWeight: PropTypesRepo.textWeight,
};

/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Avatar.defaultProps = {
	bg: 'brand700',
	pos: 'relative',
	textColor: 'white',
	d: 'flex',
	align: 'center',
	justify: 'center',
	h: '40px',
	w: '40px',
	rounded: 'circle',
	textWeight: '500',
	bgSize: 'cover',
};

/* eslint-enable react/default-props-match-prop-types */

export default Avatar;
